<template>
  <div>
    <img class="bg" src="../assets/0.開始遊戲/0_2.拍照上傳/腳色介面_02-拍攝頭像頁.png" />
    <div class="previewimg">
      <img v-if="selfieSrc != null" :src="selfieSrc" />
    </div>
    <img
      v-if="isFirstTake && !isResizing"
      class="select"
      src="../assets/0.開始遊戲/0_2.拍照上傳/拍照.png"
      @click="clickImageUpload"
    />
    <img
      v-if="!isFirstTake && !isResizing && !isProcessing"
      class="retake"
      src="../assets/0.開始遊戲/0_2.拍照上傳/腳色介面_02-重拍.png"
      @click="clickImageUpload"
    />
    <img
      v-if="!isFirstTake && !isResizing && !isProcessing"
      class="ok"
      src="../assets/0.開始遊戲/0_2.拍照上傳/腳色介面_02-OK.png"
      @click="OnConfirm"
    />
    <input
      ref="uploadImageBtn"
      type="file"
      :style="{ display: 'none' }"
      accept="image/*"
      @change="uploadImage"
    />
  </div>
</template>
<script>
import Jimp from "jimp";
import DataServices from "../services/DataService";
export default {
  data() {
    return {
      selfieSrc: null,
      isFirstTake: true,
      isResizing: false,
      isProcessing: false
    };
  },
  props: {
    OnSelfieUploded: {
      type: Function
    },
    Player: {
      id: ""
    }
  },
  methods: {
    clickImageUpload() {
      const elem = this.$refs.uploadImageBtn;
      elem.click();
    },
    async OnConfirm() {
      if (!this.isProcessing) {
        this.isProcessing = true;
        var result = await DataServices.Upload({
          id: this.Player.id,
          image: this.selfieSrc,
          carType: this.Player.carType
        });
        if (result.success) {
          if (this.OnSelfieUploded) {
            this.OnSelfieUploded(result.url, result.serialNumber);
          }
        } else {
          alert("沒有偵測到頭像，請再試一次");
        }
        this.isProcessing = false;
      }
    },
    async uploadImage(e) {
      var selectedFile = e.target.files[0];
      var idxDot = selectedFile.name.lastIndexOf(".") + 1;
      var extFile = selectedFile.name
        .substr(idxDot, selectedFile.name.length)
        .toLowerCase();
      if (!(extFile == "jpg" || extFile == "jpeg" || extFile == "png")) {
        alert("不支援的圖片格式！");
        return;
      }
      this.isResizing = true;
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = async e => {
        if (e.target.result.indexOf("base64") != -1) {
          var result = "";
          if (extFile == "png") {
            result = e.target.result.replace(/^data:image\/png;base64,/, "");
          } else {
            result = e.target.result.replace(/^data:image\/jpeg;base64,/, "");
          }
          Jimp.read(Buffer.from(result, "base64"))
            .then(async image => {
              image.resize(640, Jimp.AUTO);
              var data = await image.getBase64Async(
                extFile == "png" ? Jimp.MIME_PNG : Jimp.MIME_JPEG
              );
              this.selfieSrc = data;
              this.isResizing = false;
              if (this.isFirstTake) {
                this.isFirstTake = false;
              }
            })
            .catch(() => {
              alert("不支援的圖片格式！");
            });
        } else {
          alert("不支援的圖片格式！");
        }
      };
    }
  }
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  max-width: 100vw;
}
.retake {
  position: absolute;
  top: 143vw;
  right: 50vw;
  width: 41vw;
}
.ok {
  position: absolute;
  top: 143vw;
  right: 8vw;
  width: 41vw;
}
.select {
  position: absolute;
  top: 143vw;
  right: 30vw;
  width: 41vw;
}
.previewimg {
  position: absolute;
  left: 12.5vw;
  top: 48vw;
  width: 75vw;
  height: 75vw;
  text-align: center;
  z-index: 1;
}
.previewimg img {
  max-width: 100%;
  max-height: 100%;
  display: inline-block;
  vertical-align: middle;
}
</style>
